import { makeStyles } from '@material-ui/core'

const resultsStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(7.2),
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    backgroundColor: '#F7F6FC',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: theme.spacing(1.6),
  },
  table: {
    marginTop: theme.spacing(2.4),
  },
}))

export default resultsStyles
